var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getResources } from 'app/store/selectors';
import resources from 'app/store/resources';
import api from 'app/core/api/api.js';
import { Editor } from 'app/components/TextEditor/Editor.jsx';
import LoaderSmall from 'app/components/LoaderSmall/LoaderSmall.jsx';
import { error } from 'app/components/Notifications/notify.js';
import { MUIButton } from 'app/components/Form';
import { ResizableRow } from 'app/components/ResizableContainer';
import { trim } from 'lodash';
import keyCode from 'app/libs/keyCode';
import { createPost, fetchPostsByThread, fetchPreviousPosts, updatePost } from 'app/store/reducers/reduxPosts';
import { Messages } from 'app/containers/Assets/AssetDetail/Discussions/Messages.jsx';
import classes from 'app/containers/Assets/AssetDetail/Discussions/Chat.module.scss';
import { activeUserSelector } from 'app/store/selectors/user';
import { postsLoadingSelector, sortedPostsByDateAndThreadSelector, sortedPostsByThreadSelector, } from 'app/store/selectors/reduxPosts';
const ChatComponent = (props) => {
    const { params: { threadId, postId: selectedPost }, project: projectId, collapsabeWidth, router, selectedThread, } = props;
    selectedThread(threadId);
    const dispatch = useDispatch();
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [value, setValue] = useState('');
    const [editPost, setEditPost] = useState(null);
    const scrollableZone = useRef();
    const editor = useRef({ getData: () => value, setData: setValue });
    const thread = useSelector((state) => getResources(state, 'threads', threadId));
    const userId = useSelector(activeUserSelector);
    const messages = useSelector(sortedPostsByDateAndThreadSelector(thread, threadId));
    const loading = useSelector(postsLoadingSelector);
    const sortedPosts = useSelector(sortedPostsByThreadSelector(threadId));
    const requestsConfig = { params: { headers: { [window.OVM_PROJECT_HEADER]: projectId || '' } } };
    useEffect(() => {
        dispatch(fetchPostsByThread({
            threadId,
            params: {
                headers: { [window.OVM_PROJECT_HEADER]: projectId || '' },
                queries: { page_size: 50 },
            },
        }));
    }, []);
    function leaveEdit() {
        editor.current.setData(value);
        setEditPost(null);
    }
    function onKeyDown(event) {
        if (event.key === keyCode.ESCAPE) {
            event.preventDefault();
            if (editPost)
                leaveEdit();
        }
    }
    useEffect(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    function sendEdit() {
        var _a, _b;
        const text = trim((_b = (_a = editor.current) === null || _a === void 0 ? void 0 : _a.getData) === null || _b === void 0 ? void 0 : _b.call(_a));
        if (!text && editPost) {
            return error("Message can't be empty.");
        }
        leaveEdit();
        return editPost && dispatch(updatePost({ postId: editPost.id, text, headers: requestsConfig.params.headers }));
    }
    function onEdit(post) {
        var _a, _b;
        const text = (_b = (_a = editor.current) === null || _a === void 0 ? void 0 : _a.getData) === null || _b === void 0 ? void 0 : _b.call(_a);
        setEditPost(post);
        editor.current.setData(post.text);
        setValue(text);
    }
    function sendMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (editPost)
                return sendEdit();
            const text = trim((_b = (_a = editor.current) === null || _a === void 0 ? void 0 : _a.getData) === null || _b === void 0 ? void 0 : _b.call(_a));
            if (!text) {
                editor.current.setData('');
                return Promise.resolve();
            }
            editor.current.setData('');
            setValue('');
            const response = yield dispatch(createPost({ threadId, text, headers: requestsConfig.params.headers }));
            if (scrollableZone.current)
                scrollableZone.current.scrollTop = scrollableZone.current.scrollHeight;
            api.threads
                // @ts-ignore
                .lastReadedPost({ id: thread.id, post: response.payload.id }, null, requestsConfig.params.headers)
                .then(() => {
                resources.threads.update({ id: thread.id, unreadPostCount: 0 }, { localOnly: true });
            });
        });
    }
    function onInitEditor(editor) {
        editor.editing.view.document.on('keydown', (evt, data) => {
            if (data.keyCode === 13 && !data.shiftKey) {
                sendMessage();
                evt.stop();
            }
        }, { priority: 'highest' });
    }
    function getPreviousPosts() {
        return __awaiter(this, void 0, void 0, function* () {
            const mostOldPost = sortedPosts[0];
            if (!mostOldPost || !mostOldPost.postedOn)
                return Promise.resolve();
            const response = yield dispatch(fetchPreviousPosts({ threadId: thread.id, before: mostOldPost.postedOn, params: requestsConfig.params }));
            // @ts-ignore
            if (response.payload.count <= sortedPosts.length) {
                setCanLoadMore(false);
            }
        });
    }
    return (_jsx(ResizableRow, { style: { maxHeight: '100%', height: '100%', maxWidth: `calc(100% - ${collapsabeWidth}px` }, bottomMin: 180, topMin: 180, defaultTopSize: 70, defaultBottomSize: 30, optionName: "chatHorizResizing", top: loading ? (_jsx("div", { className: "flex flex1 center alignCenter fullHeight", children: _jsx(LoaderSmall, { style: { width: 30, height: 30 } }) })) : (_jsx(Messages, { innerRef: (ref) => {
                scrollableZone.current = ref;
            }, selectedPost: selectedPost, posts: messages, router: router, onEdit: onEdit, thread: thread, getPreviousPosts: getPreviousPosts, canLoadMore: canLoadMore, userId: userId, projectId: projectId })), bottom: _jsxs("div", { className: "flex row relative fullWidth fullHeight", style: editPost ? { border: '1px solid red', borderRadius: 3 } : undefined, children: [_jsx(Editor, { disabled: loading, value: value, onInit: (ref) => {
                        editor.current = ref;
                        onInitEditor(ref);
                    }, style: { height: 'inherit', width: 'inherit' }, customToolbar: [
                        'fontSize',
                        'fontColor',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough',
                        'codeBlock',
                        'code',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'imageUpload',
                        'insertFile',
                        'insertTable',
                        '|',
                        'undo',
                        'redo',
                    ] }), _jsx(MUIButton, { icon: "fas-paper-plane", className: classes.buttonSend, color: "primary", onClick: sendMessage, dataCy: "chat-send" })] }) }));
};
export default ChatComponent;
